import { createSelector } from '@reduxjs/toolkit';
import type { MeetingOccurrenceViewModel } from '@trinnvis/dabih-api-client';
import { getOrganization } from '../organization/getOrganization';

export const meetingOccurrencesNotDeleted = createSelector(
  getOrganization,
  (organization): MeetingOccurrenceViewModel[] => {
    if (organization === undefined) return [];
    return organization.meetingOccurrences ?? [];
  },
);
